import Vue from 'vue';
import Router from 'vue-router';
import Index from './components/index/Index';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    linkExactActiveClass: '',
    linkActiveClass: '',
    routes: [{
            path: '/menyu',
            name: 'Menu',
            component: Index,
            children: [{
                path: ':tipId',
                component: Index,
                name: 'MenuInside',
                children: [{
                    path: ':kategoriyaId',
                    component: Index,
                    name: 'MenuInside',
                    children: [{
                        path: ':vinoId',
                        component: Index,
                        name: 'MenuInside'
                    }]
                }]
            }]
        },
        {
            path: '/fotootchety',
            name: 'PhotoReports',
            component: Index,
            children: [{
                path: ':albumId',
                component: Index,
                name: 'PhotoReportsInside'
            }]
        },
        {
            path: '/anonsy',
            name: 'Advertisement',
            component: Index,
            children: [{
                path: ':itemId',
                component: Index,
                name: 'AdvertisementInside'
            }]
        },
        {
            path: '/korzina',
            name: 'Cart',
            component: Index,
            children: [{
                path: ':step',
                component: Index,
                name: 'CartStep'
            }]
        },

        {
            path: '*',
            name: 'Index',
            component: Index
        }
    ]
})